import React from 'react';
import TableContainer from '../Reusable/Table/TableContainer';

const AuditEventsTable = (props) => {
  const { eventList, t, loading, tableTitle, tableConfig, actionOnClick } =
    props || {};

  return (
    <TableContainer
      tableId="auditEvnets"
      renderAction={true}
      actionButtonStyle={'fas fa-sync-alt fa-2x'}
      action={actionOnClick}
      translations={{ ...t, tableTitle }}
      tableConfig={tableConfig()}
      items={eventList}
      loading={loading}
    />
  );
};

export default AuditEventsTable;
